import { render, staticRenderFns } from "./CreditoForm.vue?vue&type=template&id=1b015c24&scoped=true"
import script from "./CreditoForm.vue?vue&type=script&lang=js"
export * from "./CreditoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b015c24",
  null
  
)

export default component.exports